console.log('Leaflet map support activated');

var Color = require('color');

/*
var L = require('leaflet/dist/leaflet-src.js');
require('leaflet/dist/leaflet.css')

var MarkerClusterer = require('leaflet.markercluster/dist/leaflet.markercluster-src.js');
require('leaflet.markercluster/dist/MarkerCluster.css');

*/

import L from 'leaflet'
require('leaflet/dist/leaflet.css')

var Leaflet = L;

import { MarkerCluster, MarkerClusterGroup } from "leaflet.markercluster";
require('leaflet.markercluster/dist/MarkerCluster.css');
require('leaflet.markercluster/dist/MarkerCluster.Default.css');

import { GestureHandling } from "leaflet-gesture-handling";
require("leaflet-gesture-handling/dist/leaflet-gesture-handling.css");
L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

require('./style.scss');

$(document).ready(function() {
	$(document).on('click.gmap', '.gmap-trigger', function(event) {
		event.preventDefault();
		initGMap(this);
	});
	setInterval(function(){
		$('.gmap-onload').each(function(){
			$(this).removeClass('gmap-onload');
			initGMap(this);
		})
	},1000);
});


window.GMAP_INSTANCES = {};
window.HAPI_MAPS = window.HAPI_MAPS || [];

function initGMap(trigger) {

	// Defined vars
	// --------------------------------------------------------------
	var $trigger = $(trigger);

	if($trigger.data('gmapContainer'))
	{
		var $container = $($trigger.data('gmapContainer'));
		var DomContainer = $container[0];
		$container.css({position:'relative'}); // need to place tooltip
		if($container.height()==0)
		{
			var mh = $container.parent().height();
			mh = mh ? mh:$container.width()*0.6;
			$container.css({minHeight:mh+'px'}); // safari fix
		}
	}
	else
	{
		console.log('initGMap fail no container set');
		return false;
	}

	var markers = Gmap_readMarkers($container);
	var steps = Gmap_readSteps($container);
	var delta = Gmap_readDelta($container);

	var mapstyle = $trigger.data('gmapMapstyle');
	var center = $trigger.data('gmapCenter');
	var zoom = $trigger.data('gmapZoom') ? $trigger.data('gmapZoom') : 12;
	var code = $trigger.data('gmapCode') ? $trigger.data('gmapCode') : '';

	var osmStyle = 'default';
	if(typeof mapstyle =='string')
	{
		mapstyle = eval(mapstyle);
	}
	if(typeof mapstyle=='undefined')
	{
		mapstyle = null;
	}
	else
	{
		let waterColor = '#d4e8eb';
		if(mapstyle && mapstyle.length)
		{
			for(let i=0;i<mapstyle.length;i++)
			{
				let s = mapstyle[i];
				//console.log(s);
				if(s.featureType=='water' && (s.elementType=='geometry.fill' || s.elementType=='geometry'))
				{
					for(let j=0; j<s.stylers.length; j++)
					{
						let ss = s.stylers[j]
						//console.log(ss);
						if(ss.color)
							waterColor = ss.color;
					}
				}
			}
		}
		//console.log(waterColor, Color(waterColor).luminosity());
		if(Color(waterColor).luminosity()>0.8)
			osmStyle = "light";
		else if(Color(waterColor).luminosity()<0.2)
			osmStyle = "dark";
	}

	var map = Leaflet.map(DomContainer, {
		scrollWheelZoom: false,
		zoomControl: false, // no zoom default control - added in a specific position later
		gestureHandling: true,
	});
	//add zoom control with your options
	L.control.zoom({ position:'bottomright'}).addTo(map);
	var tileLayer = Leaflet.tileLayer('https://tools.mmcreation.com/osmap/'+osmStyle+'/{z}/{x}/{y}.png',{
		detectRetina: false,
		attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
	}).addTo(map);

	map.hapiCode = code;
	map.hapiZoom = zoom;

	map.hapiMarkerClassUpdate = function(clusterCode){
		var clusters = window.GMAP_INSTANCES[this.hapiCode].markers;
		for(var c in clusters)
		{
			if(clusters[c].length>1)
			{
				for(var i=0; i<clusters[c].length; i++)
				{
					//console.log(clusterCode, clusters[c], clusters[c][i]);
					if(clusters[c][i]._icon)
					{
						Leaflet.DomUtil.addClass(clusters[c][i]._icon, 'gmap-marker-cluster');

						if(clusterCode && c == clusterCode)
						{
							Leaflet.DomUtil.addClass(clusters[c][i]._icon, 'gmap-marker-cluster-active');
							Leaflet.DomUtil.removeClass(clusters[c][i]._icon, 'gmap-marker-cluster-innactive');
						}
						else if(clusterCode)
						{
							Leaflet.DomUtil.removeClass(clusters[c][i]._icon, 'gmap-marker-cluster-active');
							Leaflet.DomUtil.addClass(clusters[c][i]._icon, 'gmap-marker-cluster-innactive');
						}
						else
						{
							Leaflet.DomUtil.removeClass(clusters[c][i]._icon, 'gmap-marker-cluster-active');
							Leaflet.DomUtil.removeClass(clusters[c][i]._icon, 'gmap-marker-cluster-innactive');
						}
					}
				}
			}
		}
	}

	map.hapiReset = function(){
		map.hapiMarkerClassUpdate();
		Gmap_initialPosition($container)
	}

	map.hapiZoomIn = function(clusterCode) {
		var lat = {min:null,max:null};
		var lng = {min:null,max:null};
		var clusters = window.GMAP_INSTANCES[this.hapiCode].markers;
		for(var c in clusters)
		{
			for(var i=0; i< clusters[c].length; i++)
			{
				if(c == clusterCode)
				{
					lat.min = lat.min===null ? 1*clusters[c][i].hapiData.lat : Math.min(1*clusters[c][i].hapiData.lat , lat.min);
					lng.min = lng.min===null ? 1*clusters[c][i].hapiData.lng : Math.min(1*clusters[c][i].hapiData.lng , lng.min);
					lat.max = lat.max===null ? 1*clusters[c][i].hapiData.lat : Math.max(1*clusters[c][i].hapiData.lat , lat.max);
					lng.max = lng.max===null ? 1*clusters[c][i].hapiData.lng : Math.max(1*clusters[c][i].hapiData.lng , lng.max);
				}
			}
		}

		var bounds = Leaflet.latLngBounds([lat.min,lng.min], [lat.max,lng.max]);
		this.fitBounds(bounds,{ padding:[20,20], maxZoom: map.hapiZoom ? map.hapiZoom:12 });

		setTimeout(() => map.hapiMarkerClassUpdate(clusterCode), 200);
	}

	map.on('load',() => {
		setTimeout(() => map.hapiMarkerClassUpdate(), 500);
	})

	window.GMAP_INSTANCES[code] = {
		map:map,
		markers:{},
	}

	// Build Tooltip
	// --------------------------------------------------------------

	var tooltip_container_id = $container.attr('id')+'gmap-marker-tooltip';
	if($('#'+tooltip_container_id).length==0)
		$container.append('<div class="gmap-tooltip" id="'+tooltip_container_id+'" style="position:absolute;z-index:100;display:none;"></div>');

	// Build Marker Cluster
	// --------------------------------------------------------------

	var cluster_icon_color = $trigger.data('gmapCluster_icon_color') || '#ffffff';
	var cluster_line_color = $trigger.data('gmapCluster_line_color') || '#000000';
	var cluster_line_width = $trigger.data('gmapCluster_line_width') || 1;
	var cluster_line_scale = $trigger.data('gmapCluster_line_scale') || 3;

	var mapMarkers = [];
	window.debug = Leaflet;
	var markerCluster = Leaflet.markerClusterGroup({
		animate:false,
		spiderfyDistanceMultiplier : cluster_line_scale,
		// TODO : add spider line skin from admin
		spiderLegPolylineOptions: { weight: cluster_line_width, color: cluster_line_color, opacity: 1 },
		iconCreateFunction: function(cluster) {
			let marker = Leaflet_ClusterCalculator(cluster.getChildCount())

			let marker_icon = eval('SKIN_map_cluster_'+marker.size+'_icon');
			if(marker_icon &&  marker_icon!=='')
			{
				return L.divIcon({ html: '<span style="'
					+"transform:translate(-50%,-50%);display:inline-block;text-align:center;font-weight:bold;font-size:"+marker.icon.textSize+"px;"
					+"width:"+marker.icon.width+"px;height:"+marker.icon.height+"px;line-height:"+marker.icon.height+"px;color:"+marker.icon.textColor+";"
					+"background-image:url('"+marker_icon+"');background-size:contain;background-position:50% 50%;"
					+'">' + marker.text + '</span>' });
			}

			return L.divIcon({ html: '<span style="'
				+"transform:translate(-50%,-50%);display:inline-block;text-align:center;font-weight:bold;font-size:"+marker.icon.textSize+"px;"
				+"width:"+marker.icon.width+"px;height:"+marker.icon.height+"px;line-height:"+marker.icon.height+"px;color:"+marker.icon.textColor+";"
				+"background-image:url('"+marker.icon.url+"');background-size:contain;background-position:50% 50%;"
				+'">' + marker.text + '</span>' });
		}
	});
	markerCluster.on('spiderfied',function(v) {
		v.markers.forEach( function(element, index) {
			$(element.getElement()).addClass('leaflet-cluster-marker');
			$(element.getElement()).css({backgroundColor:cluster_icon_color});
		});
	})

	for(var i=0; i<markers.length; i++)
	{
		var marker = Leaflet.marker([1*markers[i].lat, 1*markers[i].lng], {
			icon: Leaflet_icon(markers[i].type),
			zIndexOffset:999-i,
			link: markers[i].link && !markers[i].title ? markers[i].link:null,
		})
		marker.hapiData = markers[i];
		marker.code = markers[i].code;
		marker.zoomIn = function() {
			map.setView(this.getLatLng(),15)
		}

		marker.doClick = function(mode='') {
			$('a[href^="map://"]').removeClass('active');
			if(mode=='open')
			{
				this.openPopup();
			}
			else if(mode=='close')
			{
				this.closePopup();
			}
			else if(mode=='toggle')
			{
				this.togglePopup()
			}

			if(this.isPopupOpen())
			{
				$('a[href^="map://'+code+':'+this.code+'"]').addClass('active');
			}
			//console.log(this.isPopupOpen(), 'a[href^="map://'+code+':'+this.code+'"]');
		}

		if(markers[i].title)
			marker.bindPopup(markers[i].title);

		marker.on('click', function (e) {
			let link = e.target.options.link;
			if(link && link!==null)
			{
				window.location.href = link;
			}
			this.doClick();
		});

		if(markers[i].cluster==1 || markers[i].type.cluster==1)
			markerCluster.addLayer(marker);
		else
			marker.addTo(map);

		if(!window.GMAP_INSTANCES[code].markers[markers[i].code])
			window.GMAP_INSTANCES[code].markers[markers[i].code] = [];
		window.GMAP_INSTANCES[code].markers[markers[i].code].push(marker);
	}

	map.addLayer(markerCluster);

	// Save instance in shadow DOM
	// --------------------------------------------------------------

	$container.data('gmapInstance',map);
	$container.data('gmapClusterInstance',markerCluster);
	$container.data('gmapMarkers',markers);

	Gmap_initialPosition($container);

	window.HAPI_MAPS.push($container);
}

function map_recenter(_map,delta) {
	var offsetx = window.innerWidth * delta[0]/100;
	var offsety = window.innerHeight * -delta[1]/100;
	var centerPoint = _map.getSize().divideBy(2);
	//console.log(offsetx,offsety,centerPoint);
	var targetPoint = centerPoint.subtract([offsetx, offsety]);
	//console.log(targetPoint);
	var targetLatLng = _map.containerPointToLatLng(targetPoint);
	
	_map.setView(targetLatLng);
}

function Gmap_readDelta($container)
{
	var delta = $container.data('gmapDelta');

	if(typeof delta =='string')
		delta = eval(delta);
	if(typeof delta=='undefined')
		delta = {
			desktop:[0,0],
			tablet:[0,0],
			mobile:[0,0],
		};

	if(window.innerWidth>1280)
		delta = delta && delta.desktop ? delta.desktop : [0,0];
	else if(window.innerWidth>980)
		delta = delta && delta.tablet ? delta.tablet : [0,0];
	else
		delta = delta && delta.mobile ? delta.mobile : [0,0];

	return delta;
}

function Gmap_readSteps($container)
{
	var steps = $container.data('gmapSteps');

	if(typeof steps =='string')
		steps = eval(steps);
	if(typeof steps=='undefined')
		steps = [];

	return steps;
}

function Gmap_readMarkers($container)
{
	var markers = $container.data('gmapMarkers');

	if(typeof markers =='string')
		markers = eval(markers);
	if(typeof markers=='undefined')
		markers = [];

	return markers;
}

function Gmap_invalideSize($container) {
	var map = $container.data('gmapInstance');
	map.invalidateSize();
}

function Gmap_initialPosition($container) {
	Gmap_invalideSize($container)

	var map = $container.data('gmapInstance');
	var markers = Gmap_readMarkers($container);
	var steps = Gmap_readSteps($container);
	var delta = Gmap_readDelta($container);

	var center = $container.data('gmapCenter');
	var zoom = $container.data('gmapZoom') ? $container.data('gmapZoom') : 12;

	var lat = {min:null,max:null};
	var lng = {min:null,max:null};

	// Extract overall bounds
	// --------------------------------------------------------------

	for(var i=0; i<markers.length; i++)
	{
		lat.min = lat.min===null ? 1*markers[i].lat : Math.min(1*markers[i].lat , lat.min);
		lng.min = lng.min===null ? 1*markers[i].lng : Math.min(1*markers[i].lng , lng.min);
		lat.max = lat.max===null ? 1*markers[i].lat : Math.max(1*markers[i].lat , lat.max);
		lng.max = lng.max===null ? 1*markers[i].lng : Math.max(1*markers[i].lng , lng.max);
	}
	for(var i=0; i<steps.length; i++)
	{
		lat.min = lat.min===null ? 1*steps[i].lat : Math.min(1*steps[i].lat , lat.min);
		lng.min = lng.min===null ? 1*steps[i].lng : Math.min(1*steps[i].lng , lng.min);
		lat.max = lat.max===null ? 1*steps[i].lat : Math.max(1*steps[i].lat , lat.max);
		lng.max = lng.max===null ? 1*steps[i].lng : Math.max(1*steps[i].lng , lng.max);
	}

	var bounds = Leaflet.latLngBounds([lat.min,lng.min], [lat.max,lng.max]);
	map.fitBounds(bounds,{ padding:[20,20], maxZoom: zoom ? zoom:12 });

	// Automatic zoom at level if only one marker set
	// --------------------------------------------------------------

	if(markers.length==1)
	{
		setTimeout(function(){
			map.setZoom(zoom ? zoom : 12);
		},2000);
		map_recenter(map,delta);
	}
	else
	{
		if(center && center.indexOf(',')>0)
		{
			center = center.split(',');
			center[0] = parseFloat(center[0]);
			center[1] = parseFloat(center[1]);
			setTimeout(function(){
				map.setView(center, zoom ? zoom:12);
				map_recenter(map,delta);
			},2000);
		}
		else
		{
			map_recenter(map,delta);
		}
	}
}

function Leaflet_ClusterCalculator(count)
{
	var styles = Leaflet_ClusterStyles();
	if(count>5)
		return {text: count, size:'lg', icon: styles[2]};
	else if(count>3)
		return {text: count, size:'md', icon: styles[1]};
	else
		return {text: count, size:'sm', icon: styles[0]};
}

function Leaflet_ClusterStyles()
{
	return [
		{
			anchorIcon: [24, 24],
			anchorText: [0, 0],
			fontFamily:"Arial,sans-serif",
			fontStyle:"normal",
			fontWeight:"bold",
			width:64,
			height:64,
			textColor:(window.SKIN_map_cluster_sm_text ? window.SKIN_map_cluster_sm_text : 'white'),
			textDecoration:"none",
			textSize:20,
			url:require('../icon-assets/cluster.php') + '?color=' + (window.SKIN_map_cluster_sm ? encodeURIComponent(window.SKIN_map_cluster_sm) : 'EE990099') + '&size=44'
		},
		{
			anchorIcon: [24, 24],
			anchorText: [0, 0],
			fontFamily:"Arial,sans-serif",
			fontStyle:"normal",
			fontWeight:"bold",
			width:64,
			height:64,
			textColor:(window.SKIN_map_cluster_md_text ? window.SKIN_map_cluster_md_text : 'white'),
			textDecoration:"none",
			textSize:20,
			url:require('../icon-assets/cluster.php') + '?color=' + (window.SKIN_map_cluster_md ? encodeURIComponent(window.SKIN_map_cluster_md) : 'FF550099') + '&size=54'
		},
		{
			anchorIcon: [24, 24],
			anchorText: [0, 0],
			fontFamily:"Arial,sans-serif",
			fontStyle:"normal",
			fontWeight:"bold",
			width:64,
			height:64,
			textColor:(window.SKIN_map_cluster_lg_text ? window.SKIN_map_cluster_lg_text : 'white'),
			textDecoration:"none",
			textSize:20,
			url:require('../icon-assets/cluster.php') + '?color=' + (window.SKIN_map_cluster_lg ? encodeURIComponent(window.SKIN_map_cluster_lg) : 'FF000099') + '&size=62'
		}
	];
}

function Leaflet_icon(type)
{
	var icons = {
		default:require('../icon-assets/default.png'),
		'default-cluster':require('../icon-assets/default-cluster.png'),
		none:require('../icon-assets/none.png'),
		hotel:require('../icon-assets/hotel.png'),
		'hotel-cluster':require('../icon-assets/hotel-cluster.png'),
		place:require('../icon-assets/place.png'),
		'place-cluster':require('../icon-assets/place-cluster.png'),
		step1:require('../icon-assets/step1.png'),
		step2:require('../icon-assets/step2.png'),
		step3:require('../icon-assets/step3.png'),
		step4:require('../icon-assets/step4.png'),
		step5:require('../icon-assets/step5.png'),
		step6:require('../icon-assets/step6.png'),
		step7:require('../icon-assets/step7.png'),
		step8:require('../icon-assets/step8.png'),
		step9:require('../icon-assets/step9.png'),
		step10:require('../icon-assets/step10.png'),
		step11:require('../icon-assets/step11.png'),
		step12:require('../icon-assets/step12.png'),
		step13:require('../icon-assets/step13.png'),
		step14:require('../icon-assets/step14.png'),
		step15:require('../icon-assets/step15.png'),
		step16:require('../icon-assets/step16.png'),
		step17:require('../icon-assets/step17.png'),
		step18:require('../icon-assets/step18.png'),
		step19:require('../icon-assets/step19.png'),
		step20:require('../icon-assets/step20.png'),
	};

	//console.log('Leaflet_icon',type);
	if(typeof(type)=='object')
	{
		if(type.url!==null)
		{
			// default bottom anchor
			var anchor_pad = parseInt(type.anchor_pad) || 0;
			var iconAnchor = Leaflet.point(type.size[0]/2,type.size[1] - anchor_pad);
			var popupAnchor = Leaflet.point(0,-type.size[1]);
			if(type.anchor)
			{
				switch (type.anchor)
				{
					case 'top':
						iconAnchor = Leaflet.point(type.size[0]/2,0 + anchor_pad);
						popupAnchor = Leaflet.point(0,0);
						break;
					case 'left':
						iconAnchor = Leaflet.point(0 + anchor_pad,type.size[1]/2);
						popupAnchor = Leaflet.point(type.size[0]/2,-type.size[1]/2);
						break;
					case 'right':
						iconAnchor = Leaflet.point(type.size[0] - anchor_pad,type.size[1]/2);
						popupAnchor = Leaflet.point(-type.size[0]/2,-type.size[1]/2);
						break;
					case 'center':
						iconAnchor = Leaflet.point(type.size[0]/2,type.size[1]/2);
						popupAnchor = Leaflet.point(0,-type.size[1]/2);
						break;
					case 'top-left':
						iconAnchor = Leaflet.point(0 + anchor_pad,0 + anchor_pad);
						popupAnchor = Leaflet.point(type.size[0],type.size[1]);
						break;
					case 'top-right':
						iconAnchor = Leaflet.point(type.size[0] - anchor_pad,0 + anchor_pad);
						popupAnchor = Leaflet.point(-type.size[0],type.size[1]);
						break;
					case 'bottom-left':
						iconAnchor = Leaflet.point(0 + anchor_pad,type.size[1] - anchor_pad);
						popupAnchor = Leaflet.point(type.size[0],-type.size[1]);
						break;
					case 'bottom-right':
						iconAnchor = Leaflet.point(type.size[0] - anchor_pad,type.size[1] - anchor_pad);
						popupAnchor = Leaflet.point(-type.size[0],-type.size[1]);
						break;
				}
			}
			let icon_settings = {
				iconUrl: type.url,
				size: Leaflet.point(type.size[0],type.size[1]),
				popupAnchor: popupAnchor,
				iconAnchor: iconAnchor,
				className: type.className || '',
			};
			//console.log(icon_settings);

			return Leaflet.icon(icon_settings);
		}
		else
		{
			type='default';
		}
	}

	var icon = icons.default;
	if(icons[type] != undefined)
		icon = icons[type];

	if(type.indexOf('-cluster')>=0) // les icones de cluster ont un format spécial
	{
			return Leaflet.icon({
			cluster:1,
		    iconUrl: icon,
		    iconSize: [16,16],
		    iconAnchor: [8, 8],
		    popupAnchor: [0, 0],
		});
	}
	else
	{
		return Leaflet.icon({
		    iconUrl: icon,
		    iconSize: [32,34],
		    iconAnchor: [16, 32],
		    popupAnchor: [0, 0],
		});
	}

}

// handle map reveal from map container hidden on startup (implies wrong surface size)
setInterval(function(){
	HAPI_MAPS.map(function($el,index){
		if($el.is(":visible") && $el.data('map_is_hidden')==true)
		{
			if($el.data('map_revealed')==true)
			{
				Gmap_invalideSize($el);
			}
			else
			{
				console.log('map just revealed');
				$el.data('map_is_hidden',false);
				$el.data('map_revealed',true);
				Gmap_initialPosition($el);
			}
		}
		else if(!$el.is(":visible") && $el.data('map_is_hidden')!=true)
		{
			console.log('map is now hidden');
			$el.data('map_is_hidden',true)
		}
	})
},500);